import { render, staticRenderFns } from "./causeOfDisplacement.vue?vue&type=template&id=32205a51&scoped=true&"
import script from "./causeOfDisplacement.vue?vue&type=script&lang=js&"
export * from "./causeOfDisplacement.vue?vue&type=script&lang=js&"
import style0 from "./causeOfDisplacement.vue?vue&type=style&index=0&id=32205a51&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32205a51",
  null
  
)

export default component.exports